<template>
  <div class="swiper onboarding-slider h-100 w-100">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(slide, index) in slides" :key="index">
        <div class="slide-content-wrapper">
          <img :src="slide.bgImage" class="slide-bg-image" :alt="slide.alt">
          <div class="slide-overlay"></div>
          <div class="d-flex justify-content-center align-items-center z-index-2">
            <img :src="slide.featureImage1" class="slide-feature-image feature-1" alt="featureImage1" />
            <img :src="slide.featureImage2" class="slide-feature-image feature-2" alt="featureImage2" />
          </div>
          <div class="slide-text-gradient"></div>
          <div class="slide-text-content">
            <h3 class="slide-title" v-html="formatTitle(slide.heading)"></h3>
            <p class="slide-description">
              {{ slide.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
export default {
  name: 'OnboardingSlides',
  data() {
    return {
      slides: [
        {
          bgImage: '/img/onboardingBg.jpg',
          featureImage1: '/img/onboarding2.png',
          featureImage2: '/img/onboarding1.png',
          heading: 'Your Digital Files<br/> Approved {2X} Faster',
          description: 'Ashore gets files approved twice as fast through automatic reminders, automated workflows and beautiful, white-labeled review screens that anybody can use!',
          alt: 'Promo Image 1'
        },
        {
          bgImage: '/img/onboardingBg2.jpg',
          featureImage1: '/img/onboarding4.png',
          featureImage2: '/img/onboarding3.png',
          heading: 'Collaborate on Your <br/> Proofs in {Realtime}',
          description: 'Collaborating on files has never been easier. Join your approvers, watch them navigate through your proofs. Spotlight them to see their exact view of a proof.',
          alt: 'Promo Image 2'
        },
        {
          bgImage: '/img/onboardingBg3.jpg',
          featureImage1: '/img/onboarding6.png',
          featureImage2: '/img/onboarding5.png',
          heading: '{Automate} Your <br/> Approval Process',
          description: 'Create and manage approval stages for your proofs. Every proof has a complete newsfeed of every version, comment, note and action.',
          alt: 'Promo Image 3'
        }
      ]
    };
  },
  mounted() {
    Swiper.use([Autoplay, Pagination]);
    new Swiper('.onboarding-slider', {
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
  methods: {
    formatTitle(title) {
      return title.replace(
        /\{(.+?)\}/g,
        `<span class="highlight-text">$1</span>`
      );
    }
  }
}
</script>

<style>
.slide-content-wrapper {
    height: 100%;
    position: relative;
}

.slide-bg-image {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transform: translateY(-110px);
}

.slide-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.7) 100%);
}

.slide-feature-image {
    position: absolute;
    width: 340px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    transition: all 0.3s ease;
}

.feature-1 {
    top: 30%;
    left: 25%;
}

.feature-2 {
    top: 40%;
    left: 40%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.slide-text-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 420px;
    background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.9), transparent);
    z-index: 2;
    pointer-events: none;
}

.slide-text-content {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    padding: 1rem;
    color: white;
    z-index: 3;
    max-width: 80%;
}

@media(min-width: 1440px) {
    .slide-text-content {
        max-width: 70%;
    }
}

.slide-title {
    font-size: 48px;
    line-height: 1.3;
    font-weight: bold;
    margin-bottom: 0.5rem;
    text-align: left;
}

.highlight-text {
    background-color: #019256;
    display: inline-block;
    padding: 2px 4px;
    color: white !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.slide-description {
    font-size: 16px;
    text-align: left;
    color: #919EAB;
}

.onboarding-slider {
    width: 100%;
    height: 100%;
}

.swiper-pagination {
    position: absolute;
    bottom: 20px;
}

.swiper-pagination-bullets {
    right: 24px;
    width: auto !important;
    left: unset !important;
}
</style>
